import Image from 'next/image'
import styles from './BrandBlock.module.scss'

export default function BrandBlock(props) {
  const {
    subheading,
    heading,
    description,
    brandOneDescription,
    brandTwoDescription,
    brandThreeDescription,
    brandFourDescription,
    brandFiveDescription,
    brandSixDescription
  } = props.fields

  const { brandOneHeadline, brandTwoHeadline, brandThreeHeadline, brandFourHeadline, brandFiveHeadline, brandSixHeadline } = props.fields

  const { brandOneLogo, brandTwoLogo, brandThreeLogo, brandFourLogo, brandFiveLogo, brandSixLogo } = props.fields

  const brands = [
    { logo: brandOneLogo, headline: brandOneHeadline, description: brandOneDescription },
    { logo: brandTwoLogo, headline: brandTwoHeadline, description: brandTwoDescription },
    { logo: brandThreeLogo, headline: brandThreeHeadline, description: brandThreeDescription },
    { logo: brandFourLogo, headline: brandFourHeadline, description: brandFourDescription },
    { logo: brandFiveLogo, headline: brandFiveHeadline, description: brandFiveDescription },
    { logo: brandSixLogo, headline: brandSixHeadline, description: brandSixDescription }
  ]

  return (
    <div className={styles.brandBlock} data-aos="fade-up">
      <div className={styles.brandBlockWrapper}>
        {subheading && <p className={styles.subheading}>{subheading}</p>}
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {description && (
          <div
            dangerouslySetInnerHTML={{
              __html: description
            }}
          ></div>
        )}

        <div className={styles.brandsList}>
          {brands.map(
            (brand, index) =>
              (brand.logo || brand.headline || brand.description) && (
                <div key={index} className={styles.brand}>
                  {brand.logo?.node?.sourceUrl && (
                    <div className={styles.image}>
                      <Image src={brand.logo.node.sourceUrl} alt={brand.headline || 'Brand Logo'} width={50} height={50} sizes="50px" />
                    </div>
                  )}
                  {brand.headline && <h3 className={styles.headline}>{brand.headline}</h3>}
                  {brand.description && (
                    <div
                      className={styles.WYSIWYG}
                      dangerouslySetInnerHTML={{
                        __html: brand.description
                      }}
                    ></div>
                  )}
                </div>
              )
          )}
        </div>
      </div>
    </div>
  )
}
